import React from "react";
import Button from "@mui/material/Button";
import clsx from "clsx";

import "../../../../../sass/components/organisms/zerostate/ZeroStateHero.scss";
import { Loading } from "../../../../common/components/Loading";

/**
 * The enum values here map to CSS class name suffixes (e.g., `zsh-container-upsell`).
 */
export enum ZeroStateVariant {
  DEFAULT,
  UPSELL = "upsell",
  LOADING = "loading",
}

export enum ZeroStateAlign {
  LEFT,
  CENTER,
}

type ZeroStateHeroProps = {
  title?: string;
  text: string;
  ctaButtonText?: string;
  ctaButtonOnClick?: () => void;

  variant?: ZeroStateVariant;
  imageURL?: string;
  videoURL?: string;
  align?: ZeroStateAlign;
};

export const ZeroStateHero: React.FC<ZeroStateHeroProps> = ({
  title,
  text,
  ctaButtonText,
  ctaButtonOnClick,
  variant,
  imageURL,
  videoURL,
  align = ZeroStateAlign.CENTER,
}) => {
  return (
    <div
      className={clsx(
        "zsh-container",
        variant !== ZeroStateVariant.DEFAULT ? `zsh-container-${variant}` : null,
        align === ZeroStateAlign.CENTER ? "text-center" : "",
      )}
    >
      {title && <h2 className="mt-sm">{title}</h2>}
      {variant == ZeroStateVariant.LOADING && <Loading />}
      <p>{text}</p>
      <div
        className={clsx("flex-row", align === ZeroStateAlign.CENTER ? "flex--justify-center" : "")}
      >
        {ctaButtonText && ctaButtonOnClick && (
          <Button color="primary" variant="contained" onClick={ctaButtonOnClick}>
            {ctaButtonText}
          </Button>
        )}
      </div>
      {imageURL && (
        <img
          className={clsx(
            "zsh-hero-image",
            variant !== ZeroStateVariant.DEFAULT ? `zsh-hero-image-${variant}` : null,
          )}
          src={imageURL}
          alt=""
        />
      )}
      {videoURL && (
        <video
          className={clsx(
            "zsh-hero-video",
            variant !== ZeroStateVariant.DEFAULT ? `zsh-hero-video-${variant}` : null,
          )}
          autoPlay={true}
          loop={true}
        >
          <source src={videoURL} />
        </video>
      )}
    </div>
  );
};
